import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class IncomingGoodDetailsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(
        `${API_BASE_URL}/logistic-service/incoming-goods-detail`,
        params
      ),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods-detail/${id}`,
      requestOptions
    );
  }

  create(incomingGoodDetail) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(incomingGoodDetail),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods-detail`,
      requestOptions
    );
  }

  edit(incomingGoodDetail) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(incomingGoodDetail),
    };
    return this.httpProxy.fetch(
      API_BASE_URL +
        `/logistic-service/incoming-goods-detail/${incomingGoodDetail.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods-detail/${id}`,
      requestOptions
    );
  }
}
